<template>
  <div>
    <v-row v-if="!loading">
      <v-col
        v-for="artifact in artifactsList"
        :key="artifact.id"
        cols="12"
        sm="6"
        md="4"
      >
        <artifact-card :artifact="artifact" />
      </v-col>
    </v-row>

    <div v-if="showLoadMore" class="text-center mt-4">
      <v-btn
        text
        color="primary"
        @click="$emit('load-more')"
        :loading="loading"
      >
        Load More
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ArtifactCard from './artifact-card.vue';

export default {
  name: 'ArtifactsList',
  components: {
    ArtifactCard,
  },
  props: {
    artifactsList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showLoadMore: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
